import styled from 'styled-components';
import { zIndex } from '../global/globals';
import { fadeOut } from '../base/keyframes/fades';

const StyledEntryMask = styled.div`
	position: fixed;
	top: 0; right: 0;
	left: 0; bottom: 0;
	background: ${props => props.theme.colors.grayLight};
	z-index: ${zIndex.entryMask};
	animation: ${fadeOut} 600ms ease forwards;
	pointer-events: none;
`;

export default StyledEntryMask;
